export default __webpack_public_path__ + "static/media/net.0dff38f6.svg";